import { createStore } from 'vuex'

export default createStore({
    // アプリケーションの状態（情報）
    state: {
        /* User */
        // userId: '',
        userName: '',
        userEmail: null,
        userAvatar: null,
        userGender: null,
        userDob: null,

        userToken: null,
        user: {},
        userData: null,
        teamData: null,

        /* fullScreen - fullscreen form layout (e.g. login page) */
        isFullScreen: false,

        /* Aside */
        isAsideMobileExpanded: false,
        isAsideLgActive: false,
        showSubmenuInfo: {
            isShow: true,
            label: 'ランキング'
        },

        /* Dark mode */
        darkMode: false,

        /* Field focus with ctrl+k (to register only once) */
        isFieldFocusRegistered: false,

        /* TeamActivity */
        activityMobileExpanded: false,

        trainingVideo: null,
        trainingMenu: [],
        isFirstLogin: false,        

        rankTotalingRange: ''
    },
    // stateを更新する
    // 呼び出し方
    // store.commit('mutation名', payload)
    mutations: {
        setTrainingData(state, payload) {
            state.trainingMenu = payload
        },
        setTrainingVideo(state, payload) {
            state.trainingVideo = payload
        },
        setToken(state, payload) {
            state.userToken = payload
        },
        // logout (state, user) {
        //     state.userId = ''
        //     state.userToken = ''
        // },
        /* A fit-them-all commit */
        basic(state, payload) {
            state[payload.key] = payload.value
        },
        setSubmenuInfo(state, payload) {
            state.showSubmenuInfo = payload
        },
        /* User */
        user(state, payload) {
            if (payload.last_name && payload.first_name) {
                state.userName = payload.last_name + ' ' + payload.first_name
            }
            if (payload.avatar) {
                state.userAvatar = payload.avatar
            }
        },
        setUserData(state, payload) {
            state.userData = payload
        },
        setBasicInfo(state, payload) {
            state.userToken = payload.token
            state.user = payload.user
            state.userName = payload.user.last_name + ' ' + payload.user.first_name
            state.teamData = payload.team
            state.teamName = payload.team.name
            state.userData = payload.user_data
        },
        setIsFirstLogin(state, payload) {
            state.isFirstLogin = payload
            console.log('setIsFirstLogin', payload, state.isFirstLogin)
        },

        setRankTotalingRange(state, payload) {
            state.rankTotalingRange = payload
        }
    },
    // 非同期通信や外部APIとのやりとりを行う
    // 呼び出し方
    // store.dispatch.action名
    actions: {
        asideMobileToggle({ commit, state }, payload = null) {
            const isShow = payload !== null ? payload : !state.isAsideMobileExpanded

            document.getElementById('app').classList[isShow ? 'add' : 'remove']('ml-[100px]', 'pr-24', 'lg:pr-0')

            document.documentElement.classList[isShow ? 'add' : 'remove']('m-clipped')

            commit('basic', {
                key: 'isAsideMobileExpanded',
                value: isShow
            })
        },
        asideLgToggle({ commit, state }, payload = null) {
            commit('basic', { key: 'isAsideLgActive', value: payload !== null ? payload : !state.isAsideLgActive })
        },
        showSubmenuToggle({ commit, state }, payload) {
            commit('setSubmenuInfo', {
                isShow: payload.isShow || !state.showSubmenuInfo.isShow,
                label: payload.label
            })
        },
        fullScreenToggle({ commit, state }, value) {
            commit('basic', { key: 'isFullScreen', value })

            document.documentElement.classList[value ? 'add' : 'remove']('full-screen')
        },
        darkMode({ commit, state }) {
            const value = !state.darkMode

            document.documentElement.classList[value ? 'add' : 'remove']('dark')

            commit('basic', {
                key: 'darkMode',
                value
            })
        },
        // チーム活動履歴のトグル処理
        activityMobileToggle({ commit, state }, payload = null) {
            const isShow = payload !== null ? payload : !state.activityMobileExpanded

            document.documentElement.classList[isShow ? 'add' : 'remove']('m-clipped')

            commit('basic', {
                key: 'activityMobileExpanded',
                value: isShow
            })
        },
    },
    modules: {
    },
    // stateの一部やstateから返された値を保持する
    getters: {
        inTeam(state) {
            return !!state.teamData
        }
    }
})
